module.exports = __webpack_public_path__ + "img/img_about06.5598ff16.jpg";